// Main javascript entry point
// Should handle bootstrapping/starting application

'use strict';
import compReportIsotope from './components/compReportIsotope';
import compFiltergroup from './components/compFiltergroup';

$(() => {
  compReportIsotope();
  compFiltergroup();
});
